import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AddPaymentMethodWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${Spacing.S12};
`
